<template>
    <article class="card-ticket is-size-7-mobile is-size-6-tablet">
        <div class="card-ticket-container">
            <button class="delete" aria-label="delete" @click="removeFromCart"></button>
            <div class="card-ticket__text card-ticket__title has-text-white-bis">{{ticket.section_name}}</div>
            <div class="card-ticket__text has-text-white-bis">Ряд {{ticket.row}} / Место {{ticket.place}}</div>
            <div class="card-ticket__text has-text-white-bis">{{ticket.price}} руб.</div>
        </div>
    </article>
</template>

<script>
    export default {
        name: "Ticket",
        props: ['ticket'],
        methods: {
            removeFromCart() {
                this.$store.dispatch('cart/removeTicketFromCart', this.ticket.id);
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/variables";

    .card-ticket {

        transition: $transition;
        background-color: #14141d; /* ToDo: color to css var */

        min-width: 12rem;
        max-width: 14rem;
        @media(min-width: $desktop) {
            min-width: 14rem;
            /*max-width: 12rem;*/
        }

        &-container {
            padding: 0.75rem;
            position: relative;
            @media(min-width: $desktop) {
                padding: 1rem;
            }
        }

        &__text {
            transition: $transition;
            color: var(--main-text-color);
            opacity: 0.75;
        }

        &__title {
            padding-right: 1rem;
        }

        &:hover {
            transform: translate(0px, -.5rem);
            box-shadow: 0px 0px 16px 0px rgba(12, 12, 18, 1); /* ToDo: color to css var */

            .card-ticket__text {
                opacity: 1;
            }
        }

        &:first-child {
            margin-right: 1rem;
        }

        &:not(:last-child) {
            margin-left: 1rem;
        }

        .delete {
            position: absolute;
            right: .5rem;
            top: 0.5rem;

            &:before,
            &:after {
                transition: $transition;
            }

            &:hover {
                &:before {
                    transform: translateX(-50%) translateY(-50%) rotate(-45deg);
                    background-color: $tomatored;
                }

                &:after {
                    transform: translateX(-50%) translateY(-50%) rotate(135deg);
                    background-color: $tomatored;
                }
            }
        }
    }
</style>
